<template>
  <el-upload
    action="/api/v1/tools/upload"
    :multiple="multiple"
    :data="data"
    :show-file-list="false"
    :on-success="handleAvatarSuccess"
    :before-upload="beforeAvatarUpload"
    :headers="{ Authorization: `Bearer ${$store.state.user.token}` }"
  >
    <slot></slot>
  </el-upload>
</template>

<script>
export default {
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  methods: {
    handleAvatarSuccess(res, file) {
      this.$emit('success', res)
    },
    beforeAvatarUpload(file) {
      const isImg = ["image/jpg","image/jpeg","image/png","image/pjpeg","image/gif","image/bmp","image/x-png"].includes(file.type)
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isImg) {
        this.$message.error("上传图片只能是 JPG | PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isImg && isLt2M;
    },
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Uploader.vue